export default __webpack_public_path__ + "static/media/12.1b795ec5.jpg";